require("core-js/modules/es.array.join");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.replace");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/esm/typeof"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/esm/typeof"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._typeof);
    global.str = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _typeof2) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-gov-report/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.filterFactoryType = filterFactoryType;
  _exports.filterOrderStatus = filterOrderStatus;
  _exports.dec2bin = dec2bin;
  _exports.filterSwitchType = filterSwitchType;
  _exports.copy = copy;
  _typeof2 = _interopRequireDefault(_typeof2);

  function filterFactoryType(uuid) {
    var ruiyin_base64 = 'cnVpeWlu';
    var lexing_base64 = 'bGV4aW5n';
    var yingwo_base64 = 'eWluZ3dv';
    var res = '';
    ruiyin_base64 === uuid && (res = 'ruiyin');
    lexing_base64 === uuid && (res = 'lexing');
    yingwo_base64 === uuid && (res = 'yingwo');
    return res;
  }

  function filterOrderStatus(type) {
    var res = '-';
    type == 1 && (res = '待质检');
    type == 2 && (res = '待确认');
    type == 3 && (res = '已完成');
    return res;
  }
  /**
   * 十进制转换为二进制
   * @param {string} num   十进制数值
   * @param {string} bit         二进制的bit位数
   */


  function dec2bin(num, Bits) {
    var resArry = [];
    var xArray = [];
    var i = 0; //除2取余

    for (; num > 0;) {
      resArry.push(num % 2);
      num = parseInt(num / 2);
      i++;
    } //倒序排列


    for (var j = i - 1; j >= 0; j--) {
      xArray.push(resArry[j]);
    } //报错


    if (Bits < xArray.length) {
      console.log("控制位小于转换位数");
    } //补0操作


    if (Bits) {
      for (var r = xArray.length; r < Bits; r++) {
        xArray.unshift("0");
      }
    }

    return xArray.join().replace(/,/g, "");
  }
  /**
   * 根据设备类型枚举设备名称
   * @param {int} type 
   */


  function filterSwitchType(type) {
    var obj = {
      0: '循环泵',
      1: '蛋白分离器',
      2: '臭氧机',
      3: '氧气锥',
      4: '智慧紫外杀菌',
      5: '热泵',
      6: '生物池过滤鼓风机',
      7: '智慧微滤机',
      8: '溶氧检测仪',
      9: '投料机'
    };
    return obj[type] || '-';
  } // 拷贝对象或者数组


  function copy(obj) {
    if ((0, _typeof2.default)(obj) != 'object') {
      return obj;
    }

    return JSON.parse(JSON.stringify(obj));
  }
});